export const dropdownMenuWidth = '--dropdown-menu-width';
export const dropdownMenuOffsetX = '--dropdown-menu-offset-x';
export const dropdownMenuOffsetY = '--dropdown-menu-offset-y';
